import axios from "@/config/axios";

const state = {
  phlebioTubeInfo: null,  
  emrTubeInfo:null
};

const getters = {
  getPhlebioTubeInfo: (state) => state.phlebioTubeInfo, 
  getEmrTubeInfo: (state) => state.emrTubeInfo,
};

const actions = { 
  fetchPhlebioTubeInfo: async({ commit }, phelbioOrId) => {
    try {
      const response = await axios.get(`/phlebio-tube-info/${phelbioOrId}`);
      commit('setPhlebioTubeInfo', response.data);
    } catch (error) {
      console.error('Phlebio Tube Info API Error:', error);
    }
  }, 
  fetchEmrTubeInfo: async ({ commit }, emrOrId) => {
    try {
      const response = await axios.get(`/emr-tube-info/${emrOrId}`);
      commit('setEmrTubeInfo', response.data);
    } catch (error) {
      console.error('Emr Tube Info API Error:', error);
    }
  },

};

const mutations = {
  setPhlebioTubeInfo(state, data) {
    state.phlebioTubeInfo = data;
  }, 
  setEmrTubeInfo(state, data) {
    state.emrTubeInfo = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
